import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

export const bindDealers = (list) =>
  request({
    url: `${baseUrl}/joins-sales-cloud/v1/safetyAgent/bind`,
    method: 'POST',
    data: list
  });

export const findDealerBindPage = (agentId, params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/safetyAgent/bind/${agentId}?` + params,
    method: 'GET'
  });
};

export const unbindDealer = (bindId) =>
  request({
    url: `${baseUrl}/joins-sales-cloud/v1/safetyAgent/bind/${bindId}`,
    method: 'DELETE'
  });